import dayjs from 'dayjs';

export const formatDateForDisplay = (date: Date) => {
	return date.toLocaleString('en-US', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	});
};


export const formatDisplayDate = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  return dayjs(date).format('MMM DD YYYY');
};